const beautify = require("./beautify");

$(function () {

    function moveOrderSummary() {
        var $summary = $('.order-summary-sticky');
        var $mobileContainer = $('.order-summary-mobile');
        var $desktopContainer = $('.sticky-cart');

        if (!$summary.length || !$mobileContainer.length || !$desktopContainer.length) return;

        if ($(window).width() < 768) {
            // Move summary to mobile container
            if (!$mobileContainer.find($summary).length) {
                $summary.appendTo($mobileContainer);
            }
        } else {
            // Move summary back to desktop container
            if (!$desktopContainer.find($summary).length) {
                $summary.appendTo($desktopContainer);
            }
        }
    }

    // Run on page load
    $(window).on('load', moveOrderSummary);

    // Run on window resize (debounced)
    var resizeTimeout;
    $(window).on('resize', function () {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(moveOrderSummary, 150);
    });

    /**
     * order price and hour suggestion
     */
    $(document).on('input, change', '#address', function(){
        console.log($(this).val(), beautify.isEmpty($(this).val()));
        if(beautify.isEmpty($(this).val())){
            $('.order-address').text(`Address`);
        }else{
            $('.order-address').text($(this).val());
        }
    })
    $('#address').trigger('change');

    $(document).on('change', '#product_form, #duration, #choose-order-type, .coupon-code', function(){
        let orderItemsJson = $('#product_form').serializeJSON();

        if($('.coupon-code').is("input[type='text']")) {
            orderItemsJson.coupon_code = $('.coupon-code').val();
        }
        if($('#choose-order-type').length > 0){
            orderItemsJson.type = $('#choose-order-type').serializeJSON().type;
        }
        if ($("#duration").is("input[type='text']") || $("#duration").is("input[type='number']")) {
            // Case: plain text input
            orderItemsJson.duration = $("#duration").val();
        } else {
            // Case: radio buttons inside container
            orderItemsJson.duration = $("#duration input[name='duration']:checked").val();
        }


        let orderType = $("#choose-order-type input[name='type']:checked").val();
        $('.order-type').text(beautify.reverseSlug(orderType));

        $.ajax({
            url: url+'/api/price',
            method: 'GET',
            data: orderItemsJson,
            success: function(response) {
                // for backend suggestion
                if($('.dashboard-orders-pricing').length > 0){
                    $('.dashboard-orders-pricing').html(
                        `System Suggestion <i class="far fa-clock"></i> ${response.system_estimated_duration} • ${response.currency_symbol} ${response.total_payable} `
                    ).removeClass('hidden');
                }
                // for frontend suggestion
                if($('.sticky-cart').length > 0){
                    let additionalItemsHtml = '';
                    let totalAdditionalItemsPrice = 0;
                    let currencySymbol = response ? response.currency_symbol : '';
                    if(response && response.additional_items){
                        $.each(response.additional_items, function(index, value){
                            additionalItemsHtml += `<span class="badge badge-secondary">${value.field_name}</span>`;
                            totalAdditionalItemsPrice += parseFloat(value.price);
                        });
                    }
                    $('.order-additional-items').html(additionalItemsHtml);
                    $('.order-additional-items-price').html(currencySymbol + totalAdditionalItemsPrice.toFixed(2));
                    if(orderType == 'one_time_bidding'){
                        $('.order-total-payable').html(`Bidding`);
                        $('.coupon-container').hide();
                    }else{
                        $('.order-total-payable').html(currencySymbol + (response?.total_payable || '__'));
                        $('.coupon-container').show();
                    }
                }
            },
            error: function(xhr, status, response) {
                if( xhr.responseJSON.errors ){
                    $('.dashboard-orders-pricing').html(
                        `System Suggestion <i class="fa-solid fa-circle-exclamation text-danger"></i>`
                    ).removeClass('hidden');
                    // let elem = $('.order-create');
                    // $.each(response.errors, function(key, value){
                    //     console.log("[name='"+key+"']");
                    //     $(elem).find($("[name='"+key+"']")).removeClass('is-valid').addClass('is-invalid');
                    //     var errorInfoElem = $(elem).find($("[name='"+key+"']")).closest('div').find('.error');
                    //     if(errorInfoElem.length){
                    //         errorInfoElem.text(value);
                    //     }else{
                    //         $(elem).find($("[name='"+key+"']")).parent().append('<em id="'+key+'-error" class="error invalid-feedback">'+value+'</em>');
                    //     }
                    // });
                    return;
                }
                console.log('An error occurred while fetching the price suggestion.');
            }
        });
    })

    // join as a maintainer
    $(document).on('maintainer-created', function(e){
        // scroll to top
        $('html, body').animate({
            scrollTop: 0
        }, 'slow');
        $('.maintainer-created').show();
    });
});
